import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const JobsInNoida = () => {
  return (
    <>
      <Navbar />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Jobs in Noida – Latest Job Openings {new Date().getFullYear()}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>jobs in Noida</strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a fresher or an experienced
          professional, find your dream job in Noida NCR today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring in Noida
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Noida</li>
          <li>Marketing Jobs in Noida</li>
          <li>Finance Jobs in Noida</li>
          <li>Sales Jobs in Noida</li>
          <li>Full-time Jobs in Noida</li>
          <li>Web Development Jobs in Noida</li>
          <li>Digital Marketing Jobs in Noida</li>
          <li>Telecalling Jobs in Noida</li>
          <li>IT Jobs in Noida</li>
          <li>Technical Support Jobs in Noida</li>
          <li>App Development Jobs in Noida</li>
          <li>HR Jobs in Noida</li>
          <li>Fresher Jobs in Noida</li>
          <li>Frontend Developer Jobs in Noida</li>
          <li>Backend Developer Jobs in Noida</li>
          <li>Full Stack Developer Jobs in Noida</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> – your
          trusted platform to find verified job openings in Noida NCR. No
          registration required – apply directly!
        </p>
      </div>
      <Footer />
    </>
  );
};

export default JobsInNoida;
